export function SearchByAutoComplete(queryString, restaurants) {
    var results = queryString ?
        restaurants.filter(createStateFilter(queryString)) :
        restaurants;
    return results;
}

export function createStateFilter(queryString) {
    return state => {
        return (
            state.value
                .toLowerCase()
                .indexOf(queryString.toLowerCase()) !== -1
        );
    };
}
